/* TASK 14A — Μονόπετρο Configurator (v8 LOCKED design, production).
   Δεδομένα: πέτρες = variants κρυφού προϊόντος (option1 = spec «0.30ct · I · SI1 · EX»,
   option2 = εργαστήριο GIA/HRD, τιμή = τελική με ΦΠΑ, απόθεμα 1 — E2E-proven μηχανισμός).
   Φίλτρα: εύρη 2-tap (Χρώμα/Καθαρότητα/Κοπή) + Καράτια min-max → η λίστα του tray
   και η επιλεγμένη πέτρα ακολουθούν. Fail-closed: χωρίς έγκυρη πέτρα ή νούμερο,
   ΔΕΝ γίνεται αγορά (το ΙΕΡΟ properties[Νούμερο] γράφεται ΜΟΝΟ από το popup εδώ). */
(function () {
  'use strict';
  var root = document.querySelector('[data-mono-root]');
  if (!root) return;

  /* Επίσημη σειρά GIA (owner-directive Σ07-12 S3): καλύτερο → αριστερά.
     Πλήρης κάλυψη καταλόγου (εύρημα: J/K/L πέτρες ήταν εκτός κλίμακας = αόρατες). */
  var COLOR = ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M'];
  var CLARITY = ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2'];
  var CUT = ['EX', 'VG', 'G'];
  var AXES = { color: COLOR, clarity: CLARITY, cut: CUT };

  var selStoneEl = root.querySelector('[data-mono-selstone]');
  var propSpec = root.querySelector('[data-mono-prop-spec]');
  var propVariant = root.querySelector('[data-mono-prop-variant]');
  var propSize = document.querySelector('[data-mono-prop-size]');
  var priceEl = document.querySelector('[data-price]');
  var idInput = document.querySelector('[data-variant-id]');
  var vatNote = document.querySelector('[data-mono-vat]');
  var tray = document.querySelector('[data-mono-tray]');
  var trayList = document.querySelector('[data-mono-traylist]');
  var critEl = document.querySelector('[data-mono-crit]');
  var moreBtn = document.querySelector('[data-mono-more]');
  var sizeModal = document.querySelector('[data-mono-sizemodal]');
  var sizeField = document.querySelector('[data-mono-open-size]');
  var atcBtn = document.querySelector('[data-atc-button]');

  var ringVariants = [];
  try { ringVariants = JSON.parse(document.querySelector('[data-product-json]').textContent); } catch (e) {}

  /* Σ07-20 owner: όρια συμβατότητας ΤΟΥ δαχτυλιδιού (metafields mono.*) —
     NaN/κενό = χωρίς περιορισμό (fail-open στην πλήρη γκάμα)· shapes = έτοιμο
     για fancy cuts (αδρανές μέχρι οι πέτρες να κουβαλούν σχήμα). */
  var ringCaratMin = parseFloat(root.getAttribute('data-ring-carat-min'));
  var ringCaratMax = parseFloat(root.getAttribute('data-ring-carat-max'));
  /* Σ07-20β guard: ανάποδα όρια (min>max — ανθρώπινο λάθος στο Admin) → swap,
     ποτέ άδεια βιτρίνα από typo */
  if (!isNaN(ringCaratMin) && !isNaN(ringCaratMax) && ringCaratMin > ringCaratMax) {
    var _t = ringCaratMin; ringCaratMin = ringCaratMax; ringCaratMax = _t;
  }
  var ringShapes = (root.getAttribute('data-ring-shapes') || '')
    .split(',').map(function (s) { return s.trim().toUpperCase(); }).filter(Boolean);

  var stones = [];          /* {id, spec, lab, priceCents, carat, ci, cl, cu} */
  var selected = null;      /* επιλεγμένη πέτρα */
  var userPicked = false;   /* true ΜΟΝΟ μετά από ρητή επιλογή στο tray */
  var traySel = null;       /* προσωρινή επιλογή μέσα στο tray */
  var size = null;          /* Νούμερο (ΙΕΡΟ property — μόνο από το popup) */
  var trayExpanded = false;
  var range = { color: [0, COLOR.length - 1], clarity: [0, CLARITY.length - 1], cut: [0, CUT.length - 1] };
  var caratDomain = [0.2, 1.0];
  var carat = [0.2, 1.0];

  function money(cents) {
    return new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }
  function fmtCt(v) { return v.toFixed(2).replace('.', ','); }

  /* ---- spec parsing (adapter contract: «0.30ct · I · SI1 · EX») ---- */
  function parseStone(v) {
    var parts = (v.option1 || '').split('·').map(function (s) { return s.trim(); });
    if (parts.length < 4) return null;
    var ct = parseFloat(parts[0].replace(',', '.').replace(/ct.*/i, ''));
    var ci = COLOR.indexOf(parts[1]);
    var cl = CLARITY.indexOf(parts[2]);
    var cu = CUT.indexOf(parts[3]);
    if (isNaN(ct) || ci < 0 || cl < 0 || cu < 0) return null;
    return { id: v.id, spec: v.option1, lab: v.option2 || '', priceCents: v.price, carat: ct, ci: ci, cl: cl, cu: cu };
  }

  function matching() {
    return stones.filter(function (s) {
      return s.ci >= range.color[0] && s.ci <= range.color[1] &&
        s.cl >= range.clarity[0] && s.cl <= range.clarity[1] &&
        s.cu >= range.cut[0] && s.cu <= range.cut[1] &&
        s.carat >= carat[0] - 0.0001 && s.carat <= carat[1] + 0.0001;
    }).sort(function (a, b) { return a.priceCents - b.priceCents; });
  }

  function ringPriceCents() {
    var vid = idInput && parseInt(idInput.value, 10);
    var v = ringVariants.find(function (rv) { return rv.id === vid; });
    return v ? v.price : null;
  }

  function specDisplay(s) { return s.spec.replace('.', ',') + ''; }

  function renderSelected() {
    if (selected) {
      selStoneEl.innerHTML = '<span>' + specDisplay(selected) + '</span><span class="mono__chip">◈ ' + selected.lab + '</span>';
      propSpec.value = selected.spec + ' · ' + selected.lab;
      propVariant.value = String(selected.id);
      propSpec.disabled = false;
      propVariant.disabled = false;
      window.__monoPendingStone = { id: selected.id, spec: selected.spec + ' · ' + selected.lab, ringSku: root.getAttribute('data-ring-sku') || '' };
      var ring = ringPriceCents();
      if (priceEl && ring !== null) priceEl.textContent = money(ring + selected.priceCents);
      if (vatNote) vatNote.hidden = false;
      if (atcBtn) atcBtn.disabled = false;
    } else {
      selStoneEl.innerHTML = '<span class="mono__note">Καμία πέτρα με αυτά τα κριτήρια — δείτε τις επιλογές</span>';
      propSpec.value = ''; propVariant.value = '';
      propSpec.disabled = true; propVariant.disabled = true;
      window.__monoPendingStone = null;
      if (vatNote) vatNote.hidden = true;
      if (atcBtn) atcBtn.disabled = true;
      var ring2 = ringPriceCents();
      if (priceEl && ring2 !== null) priceEl.textContent = money(ring2);
    }
  }

  function critText() {
    return 'Βάσει των κριτηρίων σας: Χρώμα <b>' + COLOR[range.color[0]] + '-' + COLOR[range.color[1]] + '</b> · Καθαρότητα <b>' +
      CLARITY[range.clarity[0]] + '-' + CLARITY[range.clarity[1]] + '</b> · Κοπή <b>' + CUT[range.cut[0]] + '-' + CUT[range.cut[1]] +
      '</b> · <b>' + fmtCt(carat[0]) + '-' + fmtCt(carat[1]) + ' ct</b>';
  }

  /* owner Σ07-13: το inline διαμαντάκι του tray → Δ1 tj-diamanti (η επίσημη φαρέτρα) */
  var DICO = '<svg class="tj-icon" width="26" height="26" aria-hidden="true"><use href="#tj-diamanti"/></svg>';

  function renderTray() {
    if (critEl) critEl.innerHTML = critText();
    var list = matching();
    var show = trayExpanded ? list : list.slice(0, 5);
    if (!list.length) {
      trayList.innerHTML = '<p class="mono__note" style="text-align:center;padding:18px 0">Καμία διαθέσιμη πέτρα με αυτά τα κριτήρια — χαλαρώστε τα εύρη ή μιλήστε με τον γεμολόγο μας.</p>';
    } else {
      /* owner-ruling Σ07-12 S3: ΚΑΜΙΑ έκθεση τιμής πέτρας — η γραμμή δείχνει την
         ΤΕΛΙΚΗ τιμή δαχτυλίδι+πέτρα (μοντέλο Β: μία τιμή, χωρίς ανάλυση). */
      var ringC = ringPriceCents();
      trayList.innerHTML = show.map(function (s) {
        var on = traySel && traySel.id === s.id;
        var sp = specDisplay(s).split('·').map(function (x) { return x.trim(); }).join(' <i>·</i> ');
        var priceHtml = ringC !== null
          ? '<span class="p">' + money(ringC + s.priceCents) + '</span><small>τελική τιμή με ΦΠΑ</small>'
          : '<span class="p">' + money(s.priceCents) + '</span><small>με ΦΠΑ</small>';
        return '<button type="button" class="mono__srow' + (on ? ' on' : '') + '" data-stone-id="' + s.id + '">' +
          '<span class="mono__cico mono__cico--sm">' + DICO + '</span>' +
          '<span><span class="specs">' + sp + '</span><span class="sub"><span class="mono__chip">◈ ΠΙΣΤΟΠΟΙΗΣΗ ' + s.lab + '</span></span></span>' +
          '<span class="pr">' + priceHtml + '</span>' +
          '<span class="mono__rad"></span></button>';
      }).join('');
    }
    if (moreBtn) moreBtn.hidden = trayExpanded || list.length <= 5;
  }

  function applyFilters() {
    /* auto-επιλογή = πάντα η ΦΘΗΝΟΤΕΡΗ matching (μοντέλο Β — τιμή ήσυχη/έμπιστη)·
       μόνο ρητή επιλογή πελάτη από το tray «κλειδώνει» όσο ταιριάζει στα φίλτρα */
    var list = matching();
    var keep = userPicked && selected && list.some(function (s) { return s.id === selected.id; });
    if (!keep) {
      selected = list.length ? list[0] : null;
      userPicked = false;
    }
    traySel = selected;
    renderSelected();
    renderTray();
  }

  /* ---- accordions ανοιγοκλείνουν ---- */
  root.querySelectorAll('[data-crow-toggle]').forEach(function (h) {
    h.addEventListener('click', function () {
      h.closest('.mono__crow').classList.toggle('mono__crow--open');
    });
  });

  /* ---- grades: 2-tap range (v8 pattern) ---- */
  root.querySelectorAll('[data-mono-range]').forEach(function (row) {
    var axis = row.getAttribute('data-mono-range');
    var values = row.getAttribute('data-values').split(',');
    row.innerHTML = values.map(function (v) { return '<button type="button" class="mono__gcell">' + v + '</button>'; }).join('');
    var cells = Array.prototype.slice.call(row.querySelectorAll('.mono__gcell'));
    var start = null;
    function paint(a, b) {
      var i1 = Math.min(a, b), i2 = Math.max(a, b);
      cells.forEach(function (c, i) {
        c.classList.toggle('end', i === i1 || i === i2);
        c.classList.toggle('in', i > i1 && i < i2);
      });
      range[axis] = [i1, i2];
    }
    paint(0, cells.length - 1);
    cells.forEach(function (c, i) {
      c.addEventListener('click', function (e) {
        e.stopPropagation();
        if (start === null) { start = i; paint(i, i); } else { paint(start, i); start = null; }
        applyFilters();
      });
    });
  });

  /* ---- carat slider + fields ---- */
  var knobMin = document.querySelector('[data-carat-knob="min"]');
  var knobMax = document.querySelector('[data-carat-knob="max"]');
  var fieldMin = document.querySelector('[data-carat-input="min"]');
  var fieldMax = document.querySelector('[data-carat-input="max"]');
  function pctToCt(p) { return caratDomain[0] + (caratDomain[1] - caratDomain[0]) * (p / 100); }
  function ctToPct(v) { return Math.round(((v - caratDomain[0]) / (caratDomain[1] - caratDomain[0])) * 100); }
  function syncCaratUI() {
    if (fieldMin) fieldMin.value = fmtCt(carat[0]);
    if (fieldMax) fieldMax.value = fmtCt(carat[1]);
    if (knobMin) knobMin.value = ctToPct(carat[0]);
    if (knobMax) knobMax.value = ctToPct(carat[1]);
  }
  function onKnob() {
    var a = pctToCt(parseInt(knobMin.value, 10));
    var b = pctToCt(parseInt(knobMax.value, 10));
    carat = [Math.min(a, b), Math.max(a, b)];
    carat = [Math.round(carat[0] * 100) / 100, Math.round(carat[1] * 100) / 100];
    syncCaratUI();
    applyFilters();
  }
  if (knobMin && knobMax) { knobMin.addEventListener('input', onKnob); knobMax.addEventListener('input', onKnob); }
  function onField() {
    var a = parseFloat((fieldMin.value || '').replace(',', '.'));
    var b = parseFloat((fieldMax.value || '').replace(',', '.'));
    if (isNaN(a)) a = caratDomain[0];
    if (isNaN(b)) b = caratDomain[1];
    carat = [Math.min(a, b), Math.max(a, b)];
    syncCaratUI();
    applyFilters();
  }
  if (fieldMin && fieldMax) { fieldMin.addEventListener('change', onField); fieldMax.addEventListener('change', onField); }

  /* ---- tray ---- */
  document.querySelectorAll('[data-mono-open-tray]').forEach(function (b) {
    b.addEventListener('click', function () { traySel = selected; trayExpanded = false; renderTray(); if (tray) tray.showModal(); });
  });
  if (moreBtn) moreBtn.addEventListener('click', function () { trayExpanded = true; renderTray(); });
  if (trayList) trayList.addEventListener('click', function (e) {
    var rowEl = e.target.closest('[data-stone-id]');
    if (!rowEl) return;
    var id = parseInt(rowEl.getAttribute('data-stone-id'), 10);
    traySel = stones.find(function (s) { return s.id === id; }) || null;
    renderTray();
  });
  var confirmBtn = document.querySelector('[data-mono-confirm]');
  if (confirmBtn) confirmBtn.addEventListener('click', function () {
    if (traySel) { selected = traySel; userPicked = true; renderSelected(); }
    if (tray) tray.close();
  });

  /* ---- size popup (ΙΕΡΟ Νούμερο — μόνο εδώ) ---- */
  var sizeTemp = null;
  if (sizeField) sizeField.addEventListener('click', function () { sizeTemp = size; paintSizes(); if (sizeModal) sizeModal.showModal(); });
  function paintSizes() {
    document.querySelectorAll('[data-mono-size]').forEach(function (b) {
      b.classList.toggle('on', sizeTemp !== null && b.getAttribute('data-mono-size') === sizeTemp);
    });
  }
  document.querySelectorAll('[data-mono-size]').forEach(function (b) {
    b.addEventListener('click', function () { sizeTemp = b.getAttribute('data-mono-size'); paintSizes(); });
  });
  var sizeConfirm = document.querySelector('[data-mono-sizeconfirm]');
  if (sizeConfirm) sizeConfirm.addEventListener('click', function () {
    if (sizeTemp !== null) {
      size = sizeTemp;
      if (propSize) { propSize.value = size; propSize.disabled = false; }
      var selval = document.querySelector('[data-mono-selval]');
      var hint = document.querySelector('[data-mono-sizehint]');
      if (selval) { selval.textContent = size.replace('.', ','); selval.hidden = false; }
      if (hint) hint.hidden = true;
      if (sizeField) sizeField.classList.remove('mono--attn');
    }
    if (sizeModal) sizeModal.close();
  });

  /* «Τι είναι;» popups (owner Σ07-13): σκονάκι ανά χαρακτηριστικό. Trigger = span
     role=button ΜΕΣΑ στο crow-header button (nested button = invalid) → stopPropagation
     ώστε το tap να ΜΗΝ ανοιγοκλείνει και το crow. */
  var whatModal = document.querySelector('[data-mono-whatmodal]');
  document.querySelectorAll('[data-mono-what]').forEach(function (t) {
    var openWhat = function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!whatModal) return;
      var k = t.getAttribute('data-mono-what');
      whatModal.querySelectorAll('[data-what-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-what-panel') !== k;
      });
      whatModal.showModal();
    };
    t.addEventListener('click', openWhat);
    t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') openWhat(e); });
  });

  /* κλείσιμο modals: ✕ + click στο backdrop */
  document.querySelectorAll('[data-mono-close]').forEach(function (b) {
    b.addEventListener('click', function () { var d = b.closest('dialog'); if (d) d.close(); });
  });
  [tray, sizeModal, whatModal].forEach(function (d) {
    if (!d) return;
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
  });

  /* ---- ATC/buy-now gate: χωρίς πέτρα ΔΕΝ προχωράμε (capture πριν από όλους).
     Το Νούμερο = ΠΡΟΑΙΡΕΤΙΚΟ (owner Σ07-12 S2: κενό νούμερο = στέλνουμε το άμεσα
     διαθέσιμο — γρηγορότερη εξυπηρέτηση + κίνηση στοκ· γίνεται δωρεάν προσαρμογή νούμερου — owner-concept Σ07-13). ---- */
  document.addEventListener('click', function (e) {
    var isAtc = e.target.closest('[data-atc-button]');
    var isBuyNow = e.target.closest('[data-buy-now]');
    if (!isAtc && !isBuyNow) return;
    if (!selected) {
      e.preventDefault(); e.stopImmediatePropagation();
      alert('Επιλέξτε πρώτα διαμάντι από τα «Διαθέσιμα Διαμάντια».');
    }
  }, true);

  /* variant switch (14Κ/18Κ): το product.js ξαναγράφει την τιμή — ξαναβάζουμε το σύνολο */
  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-swatch]')) renderSelected();
  });

  /* ---- load πέτρες ----
     Τροφοδότης = section monopetro-stone-feed (Liquid paginate 250/σελίδα) ώστε
     να έρχονται ΟΛΕΣ οι πέτρες — το /products/<handle>.js κόβει στα 250.
     Αν ο τροφοδότης λείπει/σκάσει → fallback στο .js (πρώτες 250: λίγες > καθόλου). */
  function feedUrl(page) {
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return rootUrl + '?section_id=monopetro-stone-feed&page=' + page;
  }
  function fetchFeedPage(page) {
    return fetch(feedUrl(page)).then(function (r) {
      if (!r.ok) throw new Error('feed http ' + r.status);
      return r.text();
    }).then(function (html) {
      var m = html.match(/<script[^>]*data-mono-stone-feed[^>]*>([\s\S]*?)<\/script>/);
      if (!m) throw new Error('no feed payload');
      return JSON.parse(m[1]);
    });
  }
  function loadAllStones() {
    return fetchFeedPage(1).then(function (first) {
      if (!first.stones || !first.stones.length) throw new Error('feed empty');
      var jobs = [];
      for (var p = 2; p <= (first.pages || 1); p++) jobs.push(fetchFeedPage(p));
      return Promise.all(jobs).then(function (more) {
        var all = first.stones.slice(), seen = {};
        all.forEach(function (v) { seen[v.id] = true; });
        more.forEach(function (f) {
          (f.stones || []).forEach(function (v) {
            if (!seen[v.id]) { seen[v.id] = true; all.push(v); }
          });
        });
        return all;
      });
    }).catch(function () {
      return fetch('/products/' + root.getAttribute('data-stone-handle') + '.js')
        .then(function (r) { if (!r.ok) throw new Error('no stone product'); return r.json(); })
        .then(function (p) { return p.variants || []; });
    });
  }
  loadAllStones()
    .then(function (variants) {
      stones = variants.filter(function (v) { return v.available; })
        .map(parseStone).filter(function (s) { return s !== null; });
      /* Σ07-20: φίλτρο συμβατότητας δαχτυλιδιού — πέτρες εκτός ορίων ΔΕΝ εμφανίζονται
         ποτέ σε αυτό το PDP (η μπάρα καρατιών προσαρμόζεται μόνη της από το domain) */
      if (!isNaN(ringCaratMin)) {
        stones = stones.filter(function (s) { return s.carat >= ringCaratMin - 0.0001; });
      }
      if (!isNaN(ringCaratMax)) {
        stones = stones.filter(function (s) { return s.carat <= ringCaratMax + 0.0001; });
      }
      if (ringShapes.length) {
        stones = stones.filter(function (s) { return !s.shape || ringShapes.indexOf(s.shape) >= 0; });
      }
      if (stones.length) {
        var cts = stones.map(function (s) { return s.carat; });
        caratDomain = [Math.floor(Math.min.apply(null, cts) * 10) / 10, Math.ceil(Math.max.apply(null, cts) * 10) / 10];
        carat = [caratDomain[0], caratDomain[1]];
        syncCaratUI();
        applyFilters();
      } else {
        selected = null;
        renderSelected();
        selStoneEl.innerHTML = '<span class="mono__note">Δεν υπάρχουν διαθέσιμα διαμάντια — μιλήστε με τον γεμολόγο μας.</span>';
      }
    })
    .catch(function () {
      /* fail-CLOSED: χωρίς πέτρες δεν πουλάμε «γυμνό» μονόπετρο σε τιμή σκελετού */
      selected = null;
      renderSelected();
      selStoneEl.innerHTML = '<span class="mono__note">Οι επιλογές διαμαντιών δεν είναι διαθέσιμες — καλέστε μας στο 210 923 2798.</span>';
    });
})();
